import React from 'react';
import Navbar from '../Navigation/Navbar';
import Breadcrumb from '../Navigation/Breadcrumb';
import QuickActions from '../Navigation/QuickActions';

const Layout = ({ children, breadcrumbItems = [] }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <Breadcrumb customItems={breadcrumbItems} />
      <main className="flex-1">
        {children}
      </main>
      <QuickActions />
    </div>
  );
};

export default Layout;